var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aha-button',{staticClass:"present-button",attrs:{"size":"sm"},on:{"click":_vm.handlePresentNowButtonClick}},[(!_vm.isCheckingPerm)?_c('aha-icon',{attrs:{"name":"play","width":"10","height":"10","viewBox":"0 0 24 24"}}):_c('aha-spinner',{attrs:{"variant":"white"}}),_c('span',{staticClass:"ml-1"},[_vm._v("Present")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }